export const shouldIncludeAudio = () => {
  const params = new URLSearchParams(window.location.search);
  const includeAudio = params.get('audio');
  return includeAudio === 'true';
};
